import { render, staticRenderFns } from "./BackgroundErrorsList.vue?vue&type=template&id=e4c7bab8&"
import script from "./BackgroundErrorsList.vue?vue&type=script&lang=js&"
export * from "./BackgroundErrorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports